export default __webpack_public_path__ + "static/media/crying.46bb89f2.png";